import Modal from 'core/components/Modal/Modal';
import { useAppDispatch } from 'core/hooks/use-app-dispatch';
import { useAppSelector } from 'core/hooks/use-app-selector';
import { useTranslationWrapper } from 'core/hooks/use-translation-wrapper';
import { InternationalizationNameSpace } from 'core/models/internationalization-namespace';
import { setIsOpenSalesCompanyCodesGuide } from 'feature/auth/store';
import { applicableSalesCompanyCodes } from 'feature/auth/utils/utils';
import { useCallback } from 'react';
import { configApp } from 'core/config';
import { setActiveModal } from 'core/layout/reducer';
import { convertCountryCodeToCountryName } from 'feature/companies/utils';
import { Button } from 'hfs-common-ui';
import * as S from './styled';

const AboutSalesCompanyCodes = () => {
  const { t } = useTranslationWrapper(InternationalizationNameSpace.Auth);
  const isOpen = useAppSelector((state) => state.auth.isOpenSalesCompanyCodesGuide);
  const entries = Array.from(applicableSalesCompanyCodes.entries());
  const midpoint = Math.ceil(entries.length / 2);
  const firstHalf = entries.slice(0, midpoint);
  const secondHalf = entries.slice(midpoint);
  const dispatch = useAppDispatch();

  const handleModalClose = useCallback(() => {
    dispatch(setActiveModal(null));
    dispatch(setIsOpenSalesCompanyCodesGuide(false));
  }, [dispatch]);

  return (
    <Modal title={t('AUTH:modal.title')} isOpen={isOpen} close={handleModalClose}>
      <S.DescriptionParagraph>
        {t('AUTH:modal.description')}
        <S.DescriptionAnchor href={configApp.itServicePortalUrl} target="_blank">
          {new URL(configApp.itServicePortalUrl).hostname}
        </S.DescriptionAnchor>
      </S.DescriptionParagraph>
      <div>
        <h6>{t('AUTH:modal.applicableCodes')}</h6>
        <S.ApplicableSalesCompanyCodesUl>
          <li>
            {firstHalf.map(([countryCode, code]) => (
              <S.ContainerDiv key={`${countryCode}-${code}`}>
                <span>{convertCountryCodeToCountryName(countryCode)}</span>
                <span>{code}</span>
              </S.ContainerDiv>
            ))}
          </li>
          <li>
            {secondHalf.map(([countryCode, code]) => (
              <S.ContainerDiv key={`${countryCode}-${code}`}>
                <span>{convertCountryCodeToCountryName(countryCode)}</span>
                <span>{code}</span>
              </S.ContainerDiv>
            ))}
          </li>
        </S.ApplicableSalesCompanyCodesUl>
      </div>
      <S.ButtonDiv>
        <Button size="medium" onClick={handleModalClose}>
          {t('AUTH:modal.close')}
        </Button>
      </S.ButtonDiv>
    </Modal>
  );
};

export default AboutSalesCompanyCodes;
